// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1_T30","colMaxWidth":"Table_colMaxWidth__2qlEq"};